// extracted by mini-css-extract-plugin
export default {"logoutIcon":"LogoutComponent_logoutIcon__Sc1KT"};